/** Rounded-square stop glyph shown while a response is running; uses `currentColor`. */
export type StopSquareIconProps = {
  /** Rendered width/height in px. Defaults to 16. */
  size?: number;
  className?: string;
};

function StopSquareIcon({ size = 16, className }: StopSquareIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <rect
        x="2"
        y="2"
        width="12"
        height="12"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default StopSquareIcon;
